import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/fonts.css';
import './index.css';
import App from './App';

// One-time localStorage reset. Bump this date to trigger a fresh clear for all
// users again; the marker below prevents it from repeating on every load.
const STORAGE_CLEAR_DATE = '2026-07-01';

if (localStorage.getItem('lastStorageClear') !== STORAGE_CLEAR_DATE) {
  localStorage.clear();
  localStorage.setItem('lastStorageClear', STORAGE_CLEAR_DATE);
  window.location.reload();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
